var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.871 24.7058C13.0589 24.5135 13.1641 24.2553 13.1641 23.9864C13.1641 23.7176 13.0589 23.4594 12.871 23.267L2.37537 12.5L12.871 1.73511C13.0589 1.54278 13.1641 1.28459 13.1641 1.01573C13.1641 0.746872 13.0589 0.488678 12.871 0.296345C12.7797 0.20256 12.6705 0.128017 12.5499 0.0771198C12.4293 0.0262203 12.2998 -7.55587e-08 12.1689 -8.70021e-08C12.038 -9.84454e-08 11.9084 0.0262202 11.7878 0.0771197C11.6672 0.128017 11.558 0.20256 11.4667 0.296345L0.305529 11.7483C0.1095 11.9494 -0.000211552 12.2192 -0.000211577 12.5C-0.000211601 12.7808 0.1095 13.0506 0.305529 13.2517L11.4667 24.7037C11.558 24.7974 11.6672 24.872 11.7878 24.9229C11.9084 24.9738 12.038 25 12.1689 25C12.2998 25 12.4293 24.9738 12.5499 24.9229C12.6705 24.872 12.7797 24.7974 12.871 24.7037L12.871 24.7058Z",
    fill: "#393939",
    fillOpacity: 0.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.810ae709090ec26b23ad0c9109b88137.svg";
export { ForwardRef as ReactComponent };